<div class="dialog template-dialog">
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" (click)="onClose()">close</mat-icon>
  <div mat-mdc-dialog-title>
    <h1 l10nTranslate>template.selectTemplate</h1>
  </div>
  <div class="caption" l10nTranslate>template.caption</div>
  <form>
    <div mat-dialog-content class="content">
      <div class="radio-button-block">
        <mat-radio-group name="selectedTemplateId" class="radio-group" [formControl]="templateFC">
          <mat-radio-button
            class="radio-button"
            *ngFor="let template of templatesCatalog"
            [value]="template.templateId"
          >
            {{ template.templateName }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="image-block">
        <div class="image-border" miq-bg-image [imageSrc]="selectedTemplateImageSrc"></div>
      </div>
    </div>
    <div mat-dialog-actions class="mat-mdc-dialog-actions">
      <button mat-flat-button color="primary" class="btn-submit" (click)="selectTemplate()" l10nTranslate>
        template.selectTemplate
      </button>
    </div>
  </form>
</div>
